import React, {useState, useCallback, useEffect} from 'react';
import {compose} from 'recompose';
import {hot} from 'react-hot-loader';
import {Modal, Header, Icon, Button, Form, Message} from 'semantic-ui-react';
import {withLocale} from 'op/components/locale';
import {withReportFailedKpi} from './failedKPI.helper';


const FailedKpiModal = ({locale, report, readOnly, value, remarks, onChange, clicked}) => {
    const [openModal, setOpenModal] = useState(false);
    const [fieldValue, setFieldValue] = useState(remarks);
    const [showMsg, setShowMsg] = useState(false);
    
    const onSave = () => {
        if (fieldValue) {
            onChange(fieldValue);
            setOpenModal(false);
            setShowMsg(false)
        } else {
            setOpenModal(true)
            setShowMsg(true)
        }
    };

    const onTextChange = (value)=>{
        setFieldValue(value);
        setShowMsg(false);
    }

    useEffect(() => {
        if(!readOnly && report.failkpi && clicked){
            (value !=null && value < 30) ? setOpenModal(true) : setOpenModal(false)
        }
    }, [value]);

    return (
        <Modal
            open={openModal}
            closeOnDimmerClick={false}
            style={{direction: locale._meta.rtl ? 'rtl' : 'ltr'}}
        >
            <Header icon='edit' content={locale.title}/>
            <Modal.Content>
                <Form>
                    <Form.TextArea
                        lable={locale.title}
                        value={fieldValue}
                        readOnly={readOnly}
                        onChange={(e) => onTextChange(e.target.value)}/>
                    <Message color='red' hidden={!showMsg}>
                            You have to write some remarks
                    </Message>
                </Form>

            </Modal.Content>
            <Modal.Actions>
                {/*<Button onClick={() => setOpenModal(false)} floated='left'>*/}
                {/*    <Icon name='remove'/> {locale._system.close}*/}
                {/*</Button>*/}
                <Button disabled={readOnly} onClick={onSave} primary>
                    <Icon name='save'/> {locale._system.save}
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default compose(
    hot(module),
    withReportFailedKpi,
    withLocale('report.remarks'),
)(FailedKpiModal);
